export default "__VITE_ASSET__DyJvJL0p__"